

$('.custom-ciwt.body').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 7000,
      }
    }
  ]
});
$('.custom-tes.body').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      }
    }
  ]
});
$('.hf-navtabs').slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 8,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: true,
  dots: false,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }
  ]
});




// Ready Function
$( document ).ready(function() {
  
    // 1+1 offer tag ============================
    $('#buy-one-get-one-free span.product-badge-text.tooltip-position-bottom').text('1+1 Offer');
    $('.product-single.barefoot-shoes-bogo #DiscountSaved span').text('1+1 offer');
  
    setTimeout(
    function() 
    {
       $('.product-single.barefoot-shoes-bogo .discount-sticky-price-text').text('1+1 offer');
    }, 1000);

    $("select#SingleOptionSelector-0").on('change', function() {
        setTimeout(
        function() 
        {
           $('.product-single.barefoot-shoes-bogo .discount-sticky-price-text').text('1+1 offer');
        }, 1000);
    });
    $("select#SingleOptionSelector-1").on('change', function() {
        setTimeout(
        function() 
        {
           $('.product-single.barefoot-shoes-bogo .discount-sticky-price-text').text('1+1 offer');
        }, 1000);
    });
    // 1+1 offer tag End ===========================
  
    // Collection Banner ===========================
    var waitForEl = setInterval(function() {
      if($('.hero-image.mobile').length > 0){
          $('.hero-image.mobile').css('display','none');
            clearInterval(waitForEl);
      }
    }, 200);
    // Collection Banner End =======================
  
    // Cart Drawer =================================
    var waitForDC = setInterval(function() {
      if($('.ajaxcart__general-upsell.drawer__inner-section.card-group').length > 0){
          sliderUpsell();
          clearInterval(waitForDC);
      }
    }, 200);
    var waitForDC2 = setInterval(function() {
      if($('.ajaxcart__general-upsell.drawer__inner-section.card-group').length > 0){
          textTotal();
          clearInterval(waitForDC2);
      }
    }, 3200);
  
    // Select the target node
    const targetNode = document.getElementById('CartDrawer');

    // Check if the target node exists
    if (!targetNode) {
        console.error('Target node not found');
        return;
    }

    // Create a mutation observer instance
    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                sliderUpsell();
                
                var waitForDC2 = setInterval(function() {
                  if($('div#CartDrawer p.cart__subtotal.text-money.text-large.spacer-bottom-none.text-ellipsis p:first-child').length > 0){
                      textTotal();
                      clearInterval(waitForDC2);
                  }
                }, 20);
            }
        }
    });

    // Observer configuration
    const config = {
        childList: true,
        subtree: true
    };

    // Start observing the target node
    observer.observe(targetNode, config);
  
    // Cart Drawer End =========================

    // Counter Section =========================
    $('.hf-counter').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                // $(this).text(Math.ceil(now));
               $(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
            }
        });
    });
    // End Counter Section =========================

    // Tab Section =================================
    $('.custom-tab-container>div>div:first-child').addClass('active');
    $('.hf-navtab').on('click',function(){
        var tabDataTarget = $(this).attr('data-target');
        $('.hf-navtab').removeClass('active');
        $(this).addClass('active');
        $('.navtabs-content .hf-content').removeClass('active');
        $('.navtabs-content #'+ tabDataTarget +'').addClass('active');
    });

    // End Tab Section =================================

    // Header Currency =================================
    var arr = [ "USD", "CAD", "AUD", "GBP", "EUR", "NZD", "ISK", "DKK", "PKR", "CHF", "SEK", "INR", "PLN", "CZK", "RON", "HUF", "RSD", "BGN", "KYD", "HKD" ];
    $('select#currency-list-header option').each(function( index ) {
        var currency = $(this).val();
        if($.inArray(currency, arr) == -1){
            $(this).remove();
        }
    });
    // End Header Currency =================================
  
});

// Functions
function sliderUpsell() {
  $('.ajaxcart__general-upsell.drawer__inner-section.card-group').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
  });
}

function textTotal() {
  $('div#CartDrawer p.cart__subtotal.text-money.text-large.spacer-bottom-none.text-ellipsis p:first-child').text('Total:');
}

/* Product Review Tooltip */
$(document).ready(function () {
  $('.product__review__tooltip .review-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });

  $('.js-review-tooltip-close').click(() => {
    $('.product__review__tooltip').addClass('hidden');
  });

  $('.js-show-tooltip').click(() => {
    if ($('.product__review__tooltip').hasClass('hidden')) {
      $('.product__review__tooltip').removeClass('hidden');
      return 
    }

    $('.product__review__tooltip').addClass('hidden');
  });
});
// End Ready Function

class ProductSubSizeSelector extends HTMLElement {
  static observedAttributes = ["color", "size"];

  constructor() {
    // Always call super first in constructor
    super();
    this.version = this.getAttribute("version")
  }

  groupSizes(sizeArray) {
    let womenSizes = { sizes: [] };
    let menSizes = { sizes: [] };

    let womenList = [];
    let menList = [];

    // Get separate size lists for Men and Women
    sizeArray.forEach(size => {
        const [womenSize, menSize] = size.replace(/US Women |US Men /g, "").split(" - ");
        womenList.push(womenSize);
        menList.push(menSize);
    });

    // Function to group sizes into groups of 4 elements
    function createGroups(sizeList) {
        let groupedSizes = [];
        for (let i = 0; i < sizeList.length; i += 4) {
            let group = sizeList.slice(i, i + 4); // Take 4 elements
            let minSize = group[0]; // Smallest element
            let maxSize = group[group.length - 1]; // Largest element
            groupedSizes.push({ range: `${minSize}/${maxSize}`, subSizes: group });
        }
        return groupedSizes;
    }

    // Apply grouping for Women and Men
    womenSizes.sizes = createGroups(womenList);
    womenSizes.allsizes = womenList;
    menSizes.sizes = createGroups(menList);
    menSizes.allsizes = menList

    return { womenSizes, menSizes };
  }

  detectNumbers(input) {
    let match = input.match(/US Women (\d+(?:\.\d+|\/\d+(?:\.\d+)?)?)|US Men (\d+(?:\.\d+|\/\d+(?:\.\d+)?)?)/g);
    if (!match) return [];
    
    return match.map(size => size.replace(/US Women |US Men /, ''));
  }

  addClass(element, className = 'active') {
    if (element) {
      element.classList.add(className);
    }
  }

  removeClass(element, className = 'active') {
    if (element) {
        element.classList.remove(className);
    }
  }

  triggerChange(text) {
    const selectElement = document.querySelector('select[data-option-name="size"]')
    const option = data_sizes.find(option => option?.toUpperCase()?.includes(text));

    if (selectElement && option) {
      selectElement.value = option;
      selectElement.dispatchEvent(new Event("change")); // Trigger change event
    }  
  }

  generateSizeHTML(womenSizes, menSizes) {
    let womenSizesHtml = "";
    let menSizesHtml = "";
    let womenSubSizesHtml = "";
    let menSubSizesHtml = "";

    const currentVariant = current_variant_title
    const sizes = this.detectNumbers(current_variant_title);

    // Helper function to clean size values and generate HTML
    const generateSizeButtonsHTML = (sizeGroup, gender, currentSize) => {
      let sizesHtml = "";
      let subSizesHtml = "";
      const minCurrentSize = parseFloat(currentSize.split('/')[0]);
      
      sizeGroup.forEach((size, index) => {
        const min = size.subSizes[0];
        const max = size.subSizes[size.subSizes.length - 1];
        
        // Clean min and max values to display only the first number before any slash
        const cleanMin = min.split('/')[0];
        const cleanMax = max.includes('/') ? max.split('/')[1] : max;
        const classActive = cleanMin <= minCurrentSize && minCurrentSize <= cleanMax ? "active" : "";
        
        sizesHtml += `<div class="size-selection__item size-btn ${classActive}" data-index="${index}">${cleanMin}/${cleanMax}</div>`;
        
        subSizesHtml+= `<div class="sub-size-selection__items ${classActive}">`
        size.subSizes.forEach(sub => {
          const classSubActive = sub == currentSize ? "active" : "";
          subSizesHtml += `<div class="sub-size-selection__item size-btn ${classSubActive}" data-option-text="US ${gender} ${sub}">US ${sub}</div>`;
        });
        subSizesHtml+= `</div>`
      });
      
      return { sizesHtml, subSizesHtml };
    };
  
    // Generate HTML for women's sizes
    const womenResult = generateSizeButtonsHTML(womenSizes.sizes, "women", sizes[0]);
    womenSizesHtml = womenResult.sizesHtml;
    womenSubSizesHtml = womenResult.subSizesHtml;
    
    // Generate HTML for men's sizes
    const menResult = generateSizeButtonsHTML(menSizes.sizes, "men", sizes[1]);
    menSizesHtml = menResult.sizesHtml;
    menSubSizesHtml = menResult.subSizesHtml;

    return { womenSizesHtml, menSizesHtml, womenSubSizesHtml, menSubSizesHtml };
  }

  generateSizeHTMLSecondVersion(womenSizes, menSizes) {
    let womenSizesHtml = "";
    let menSizesHtml = "";

    const currentVariant = current_variant_title
    const sizes = this.detectNumbers(current_variant_title);

    // Helper function to clean size values and generate HTML
    const generateSizeButtonsHTML = (sizeGroup, gender, currentSize) => {
      let sizesHtml = "";
      const minCurrentSize = parseFloat(currentSize.split('/')[0]);
      
      sizeGroup.forEach((size, index) => {
        const classActive = currentSize === size ? "active" : "";
        
        sizesHtml += `<div class="sub-size-selection__item size-btn ${classActive}" data-option-text="US ${gender} ${size}">US ${size}</div>`;
      });
      
      return { sizesHtml };
    };
  
    // Generate HTML for women's sizes
    const womenResult = generateSizeButtonsHTML(womenSizes.allsizes, "women", sizes[0]);
    womenSizesHtml = womenResult.sizesHtml;
    
    // Generate HTML for men's sizes
    const menResult = generateSizeButtonsHTML(menSizes.allsizes, "men", sizes[1]);
    menSizesHtml = menResult.sizesHtml;

    return { womenSizesHtml, menSizesHtml };
  }
  
  iconSizeChart() {
    return `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <mask id="mask0_25_4157" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
      <rect width="12" height="12" fill="url(#pattern0_25_4157)"/>
      </mask>
      <g mask="url(#mask0_25_4157)">
      <rect y="-1.09094" width="24" height="13.3333" fill="#222222"/>
      </g>
      <defs>
      <pattern id="pattern0_25_4157" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use xlink:href="#image0_25_4157" transform="scale(0.0104167)"/>
      </pattern>
      <image id="image0_25_4157" width="96" height="96" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAABFdJREFUeF7tnWuSnDAMhNmTJTlZkpMlOVmyqgpTFGPslizZLQN/ZqsW/OjPEnIzj4/tOaYq8DG196fz7QEweRE8ABYH8HXbtu+VOf75/N+PyRpM7T4qAnbh5RU5fv4/6XYwIgCIiLVVXwMiIG4FwROAdtVfgfi9bZuAkNflDy8AIv4vZ7W+3QGCB4AI8XeWy0PoBRAp/i0g9AAYIf7yEKwAtOKfb6xyfWuPcL6lLJmOLAC04teE05asy0HQAvAUf1/hEW06F2RxzWkARAoV2Xaceg4towBGCDSiDwfJfJtAAIwUZmRfvkoaW2sBGC2Itj+ZduobcwuA2Auoo9krhEX89PuEGgBNiThT/NQQrgBkEz8thF4ADCs/9Y75CsBf4KbeK750gfQDDOXtFI+xWfpVX1MCgKQfjydXSD/H1CJ/a545pIBQAtCqfDzE38VEKqyjkNpKiR6CBYDXpFqgr2r8pSBYALT2DmgebKWgGuhlIMwEcJWG0IfyS0CwAPBKQXuk7JGwvwtC846I9BAsAEQogcBwaAHQeUcWACyTsIhPt2MuAUAn5p2KNBGFjrHW5szxv8Z1VdEgJeKsSPAQnyYSrgBoJjlyJWnGhUbUyPG/jYnFjkbFWs47am2q0FQ0Ih21Nm5HiHuVRu8dtQBoQz4ynNHFkMo7agGQVcUCAQFQWgAs4y+mWQQAC4RWCkrpHaEAWCCUoiC1d6QBwAJhKe9IC4AFAlq2ns/T3g/CqzsLgKwQLOKH75itALJB6BE/FEIPgCwQPMQPg9ALgB2Cp/ghEDwAMEOg9468ADBCaG3cKLwjTwBsEBDr4lxmalNWt/flDYAJAgJguncUAYAFQisFUXhHUQBYINB7R5EAWCBQe0fRAFgg0HpHIwBkhaCtiM5lLfR9R6MAZIPQI75qxzwSQBYIHuLDEEYDYIfgKT4EYQYAZggR3lH1zcyzADBCaG3ceryjy491zQTABgGxLnq8o+LOezYAJggIgB7vqJiKGACwQGilIA/v6K0NFgAsEKK9o7coYALAAqHHO2qlMXoALBCivKMUALJDqO0l0gDIDGEZABkhtKyMVBGw5+HWpM75uvtBufUG8Hldq5RNCSBLJLTEl3m8WRJsZWht8TFHAjo26o0YEvnoRCErGOkQOAcdE7UVAczzdQo64REQNGMpOqKZUtARkmbiZwdTA9srJdLa0T1izISg6Zv2gUyP+DNLVI34zejLmoJmpSNX8WUSKwAYtU9wF38lANEQQsRfDUAUhDDxVwRggVD7ItpQ8VcFYIUg5eL+fk4RXn6QVF7Rw2QCrnITLomkXb2o0KXzTOKvHAHWfYIFgln8OwCwpCMNhC7x7wIgCkK3+HcCsEPQ3lhL0YB+PxEUSSvfhK8EQJ5cXV3r9dsJr/bvCEAmLxC+KMpM11V/pHtXAMcqScpVgVFb9dDnvaCcczrp7gAsmrle8wBwlVPf2ANAr5nrFQ8AVzn1jf0DaAp3cEut40UAAAAASUVORK5CYII="/>
      </defs>
      </svg>
      `
  }

  genderHtml (womenSizes, menSizes) {
    const womenMin = womenSizes.allsizes[0]
    const womenMax = womenSizes.allsizes[womenSizes.allsizes.length-1]
    const menMin = menSizes.allsizes[0]
    const menMax = menSizes.allsizes[menSizes.allsizes.length-1]

    const html = `
      <div class="gender-selection">
        <label>Gender:</label>
        <div class="gender-buttons">
          <div class="gender-btn active" data-gender="women">
            <strong>Women</strong><br><span>US - ${womenMin}/${womenMax}</span>
          </div>
          <div class="gender-btn" data-gender="men">
            <strong>Men</strong><br><span>US - ${menMin}/${menMax}</span>
          </div>
        </div>
      </div>
    `;

    return html
  }

  renderFirstVersion(womenSizes, menSizes) {  
    const { womenSizesHtml, menSizesHtml } = this.generateSizeHTMLSecondVersion(womenSizes, menSizes)
    const genderHtml = this.genderHtml(womenSizes, menSizes)
    
    const html = `
      ${genderHtml}
      <div class="sub-size-selection">
        <div class="size-selection__header">
          <label>Size:</label>
          <div class="js-size-chart">
            ${this.iconSizeChart()}
            See size guide
          </div>
        </div>
        <div class="gender-buttons active">
          ${womenSizesHtml}
        </div>
        <div class="gender-buttons">
          ${menSizesHtml}
        </div>
      </div>
    `;

    return html
  }

  renderSecondVersion(womenSizes, menSizes) {  
    const { womenSizesHtml, menSizesHtml, womenSubSizesHtml, menSubSizesHtml } = this.generateSizeHTML(womenSizes, menSizes)
    const genderHtml = this.genderHtml(womenSizes, menSizes)

    const html = `
      ${genderHtml}
      <div class="size-selection">
        <div class="size-selection__header">
          <label>Size:</label>
          <div class="js-size-chart">
            ${this.iconSizeChart()}
            See size guide
          </div>
        </div>
        <div class="gender-buttons active">
          ${womenSizesHtml}
        </div>
        <div class="gender-buttons">
          ${menSizesHtml}
        </div>
      </div>
      <div class="sub-size-selection">
        <label>Sub-size:</label>
        <div class="gender-buttons active">
          ${womenSubSizesHtml}
        </div>
        <div class="gender-buttons">
          ${menSubSizesHtml}
        </div>
      </div>
    `;

    return html
  }

  connectedCallback() {
    const { womenSizes, menSizes } = this.groupSizes(data_sizes);
    const html = this.version === '1' ? this.renderFirstVersion(womenSizes, menSizes) : this.renderSecondVersion(womenSizes, menSizes)

    this.innerHTML = html;

    const allGenderBtns = this.querySelectorAll('.gender-btn')
    const allSizeSelectors = this.querySelectorAll('.size-selection .gender-buttons')
    const allSubSizeSelectors = this.querySelectorAll('.sub-size-selection .gender-buttons')
    const allSizeBtnSelectors = this.querySelectorAll('.size-selection .gender-buttons .size-btn')
    const allSubSizeBtnSelectors = this.querySelectorAll('.sub-size-selection .size-btn')
    const sizeChart = document.querySelectorAll('.js-size-chart')

    allGenderBtns.forEach((genderBtn, index) => {
      genderBtn.addEventListener('click', () => {
        allGenderBtns.forEach(btn => this.removeClass(btn))
        allSizeSelectors.forEach(btn => this.removeClass(btn))
        allSubSizeSelectors.forEach(btn => this.removeClass(btn))

        this.addClass(genderBtn)
        this.addClass(allSizeSelectors[index])
        this.addClass(allSubSizeSelectors[index])
      })
    })

    allSizeBtnSelectors.forEach((size) => {
      size.addEventListener('click', () => {
        const allSubSizeItemsSelectors = this.querySelectorAll('.sub-size-selection .gender-buttons.active .sub-size-selection__items')
        allSubSizeItemsSelectors.forEach(btn => this.removeClass(btn))
        this.querySelectorAll('.size-selection .gender-buttons.active .size-btn').forEach(btn => this.removeClass(btn))
        
        const index = size.getAttribute('data-index')
        const currentSubItem = allSubSizeItemsSelectors[index]
        this.addClass(currentSubItem)
        this.addClass(size)
      })
    })

    allSubSizeBtnSelectors.forEach((sub, index) => {
      sub.addEventListener('click', () => {
        const activeSelectors = this.querySelectorAll('.sub-size-selection .gender-buttons.active .size-btn')
        activeSelectors.forEach(btn => this.removeClass(btn))
        this.addClass(sub)
        this.triggerChange(sub.getAttribute('data-option-text')?.toUpperCase())
      })
    })

    sizeChart.forEach((chart) => {
      chart.addEventListener('click', () => {
        const chartBox = document.querySelector('.dbtfy-size-chart-box button')
        if(chartBox) chartBox?.click()  
      })
    })
  }
}

customElements.define("product-sub-size-selector", ProductSubSizeSelector);